// extracted by mini-css-extract-plugin
module.exports = {"zigzagCardText":"VolunteerCircularImage_zigzagCardText__SMA7m","wTitle":"VolunteerCircularImage_wTitle__liS4M"};